module.exports = __webpack_public_path__ + "img/543a811.jpg";